module.exports = __webpack_public_path__ + "img/GazDeBordaux_80X30.ec730836.png";